// extracted by mini-css-extract-plugin
export default {"titleInfo":"ActivePopup_titleInfo__wQlJk","verifyButton":"ActivePopup_verifyButton__Q6XK6"};